import SubjectIcon from '@material-ui/icons/ViewList';

import DebtReminderBatchList from './DebtReminderBatchList';

export default {
  list: DebtReminderBatchList,
  icon: SubjectIcon,
};
